module.exports = __webpack_public_path__ + "static/img/bg-search-download.37fbe5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-search-download.png
// module id = 915
// module chunks = 0